// extracted by mini-css-extract-plugin
module.exports = {"header":"header--swVD1","alert":"alert--3mJbf","form":"form--10Isp","btn-line":"btn-line--2xm9V","long":"long--dpwcK"};